module.exports = __webpack_public_path__ + "img/use-cases.4bdd7c65.png";